import {
  AvailableTariffGoodType,
  AvailableTariffsData,
  DopTariff,
} from '@src/store/ducks/tariffs/types'
import { api } from './api'

export const tariffsApi = {
  getBlockDescription() {
    return api.get<string>('/v1/user/block-description')
  },
  getFreeBlockDays(accountId: number, deviceId: number) {
    return api.get<number>('/v1/user/get-free-ban-days', { accountId, deviceId })
  },
  blockTariff(
    accountId: number, serviceId: number, deviceId: number, goodTypeId: number,
    dateStart: string, dateEnd: string,
  ) {
    return api.post('/v1/user/block-service', {
      accountId, serviceId, deviceId, goodTypeId, dateStart, dateEnd,
    })
  },
  unblockService(subscription: number) {
    return api.post('/v1/user/unblock-service', {
    // return api.post('/v1/user/account/services/CheckAvailableTarifs', {
      subscription,
    })
  },
  checkAvailableDopTariffs(
    accountId: number, dogovorId: number, deviceId: number, serviceId: number,
  ) {
    return api.get<DopTariff[]>('/v1/user/check-available-dop-tariffs', {
      accountId, dogovorId, deviceId, serviceId,
    })
  },
  addDopService(accountId: number, dogovorId: number, deviceId: number, serviceId: number, newGoodId: number) {
    return api.post('/v1/user/add-dop-service', {
      accountId, dogovorId, deviceId, serviceId, newGoodId,
    })
  },
  delDopService(serviceId: number) {
    return api.del('/v1/user/del-dop-service', {
      serviceId,
    })
  },
  checkAvailableTariffs(
    type: AvailableTariffGoodType, accountId: number, dogovorId?: number, deviceId?: number, goodId?: number,
  ) {
    return api.get<AvailableTariffsData[]>('/v1/user/check-available-tariffs', {
      accountId, dogovorId, deviceId, goodId, type,
    })
  },
  changeTariff(accountId: number, dogovorId: number, deviceId: number, serviceId: number, newGoodId: number) {
    return api.post('/v1/user/change-tariff', {
      accountId, dogovorId, deviceId, serviceId, newGoodId,
    })
  },
  getTariffInfo(goodId: number) {
    return api.get<number>('/v1/user/get-tariff-info', { goodId })
  },
}
